import React from 'react';
import "../App.css";


const Grid = () => {
    return (

        <div className="grid">

            <div className="grid-col">
                <div className="grid-3-image">
                    <img src="/profile.png" alt="profile" />
                    {
                        //h 100 w 100 for desktop view
                    }
                </div>

                <h4>Experienced</h4>
                <p>Highly skilled and knowledgable technicians.</p>
            </div>


            <div className="grid-col">

                <div className="grid-3-image">
                    <img src="/money.png" alt="money" />
                </div>

                <h4>Affordable</h4>
                <p>Cheap and affordable price compare to our competitors</p>
            </div>


            <div className="grid-col">

                <div className="grid-3-image">
                    <img src="/clock.png" alt="clock" />
                </div>

                <h4>Flexible</h4>
                <p>Call us anytime, any day.</p>
            </div>




        </div>




    );
}

export default Grid;